import * as usersApi from 'api/users.api';
import { fetchAndSetInvestorProfileData } from 'components/views/InvestorEditProfile/_helpers/investorEditProfile.resolvers';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';

export const handleSubmitEditInvestorProfile = async () => {
  $view.update({ isLoading: true });
  try {
    await usersApi.updateUser($user.value.id, {
      firstName: $form.value.firstName,
      lastName: $form.value.lastName,
      roles: $form.value.roles,
      ageId: $form.value.age || null,
      genderId: $form.value.gender || null,
      ethnicityId: $form.value.ethnicity || null,
      otherConditions: $form.value.otherConditions,
      levelOfEducation: $form.value.levelOfEducation,
      undergraduateUniversity: $form.value.undergraduateUniversity,
      graduateUniversity: $form.value.graduateUniversity,
      profileImage: $form.value.profileImage,
    });

    displayNotification({
      message: 'Update successful',
      title: 'Success',
    });
  } catch (error) {
    console.error('API Error:', error);
    displayError({
      message: 'Failed to update profile. Please try again.',
      title: 'Profile Update Error',
    });
  } finally {
    $view.update({ isLoading: false });
    await fetchAndSetInvestorProfileData();
  }
};

export const handleProfileImageUpload = async (imageUrl) => {
  try {
    $form.update({ profileImage: imageUrl });
    await usersApi.updateUser($user.value.id, {
      profileImage: imageUrl,
    });
    displayNotification({
      message: 'Profile image updated successfully!',
      title: 'Success',
    });
  } catch (error) {
    displayError({
      message: 'Failed to update profile image. Please try again.',
      title: 'Image Update Error',
    });
    // Revert the form state on error
    $form.update({ profileImage: $user.value.profileImage });
  }
};

export const handleProfileImageRemove = async () => {
  try {
    $form.update({ profileImage: null });
    await usersApi.updateUser($user.value.id, {
      profileImage: null,
    });
    displayNotification({
      message: 'Profile image removed successfully!',
      title: 'Success',
    });
  } catch (error) {
    displayError({
      message: 'Failed to remove profile image. Please try again.',
      title: 'Image Removal Error',
    });
    // Revert the form state on error
    $form.update({ profileImage: $user.value.profileImage });
  }
};
